import { useEffect, useState } from 'react';
import {
  Accordion, AccordionDetails, AccordionSummary, Button
} from '@mui/material';
import { useSelector } from 'react-redux';
import {
  Body2500C, Body4300N, Body4400N, Body4400U, CAPTION_TEXT_1, CAPTION_TEXT_2, HEADING_TEXT_2, MONTH_SELECTOR_ICON
} from '../../../utilities/generatedClasses';
import Icon from '../../../components/Icon';
import RcmndtnDetailsSkeleton from './skeleton/RcmndtnDetailsSkeleton';
import RecommendationAccess from '../../../dataAccess/RecommendationAccess';
import { cleanData, parseSqlArray } from '../../../utilities/utils';
import { classNameTriskeleParser } from '../../../utilities/customStyles';

const RecommendationDetails = (props) => {
  const [recommendationDetails, setRecommendationDetails] = useState(null);
  const [skeleton, setSkeleton] = useState(false);
  const [action, setAction] = useState(null);
  const [isRecommendationInPast, setRecommendationInPast] = useState(false);
  const {
    data, dataIndex, windowWidth, selectedItem, openEditOccurenceDialog, openEditSeriesDialog,
    deleteOccurence, deleteSeries, openUserProfile
  } = props;

  const contextcache = useSelector(state => state.context);

  const setQtyUnitArrayString = (qtyData) => {
    const { selectedMeasure } = selectedItem;
    const { MeasureCmpntCount } = selectedMeasure;
    const measureCmpntArray = selectedMeasure.UnitArray !== 'NULL'
      ? cleanData(selectedMeasure.UnitArray) : [];


    const firstPropUnitName = contextcache.units.find(unit => unit.UnitID === qtyData[0].UnitId).UnitAbrvName;

    if (qtyData.length  == 4) {
      const firstProp = qtyData[0].QtyDescrptr.substring(0, 3).toLowerCase();
      const secondProp = qtyData[2].QtyDescrptr.substring(0, 3).toLowerCase();
      const unit = contextcache.units.find(unit => unit.UnitID === qtyData[0].UnitId).UnitAbrvName;

      return `${firstProp} ${qtyData[0].Qty}-${qtyData[1].Qty} ${unit} - ${secondProp} ${qtyData[2].Qty}-${qtyData[3].Qty} ${unit} `;
    } if (qtyData.length === 2) {
      return `${qtyData[0].Qty}-${qtyData[1].Qty} ${firstPropUnitName}`;
    }
    return `${qtyData[0].Qty} ${firstPropUnitName}`;
  };

  const getData = (result) => {
    if (result.ChangedOccurncArray) {
      result.ChangedOccurncArray = cleanData(result.ChangedOccurncArray);
    }
    if(props.data && props.data.QtyDescrptr_Qty_UnitIdArray && props.data.QtyDescrptr_Qty_UnitIdArray[0] &&
      props.data.QtyDescrptr_Qty_UnitIdArray[0].QtyDescrptr == "Hours"
     ){
      result.QtyDescrptr_Qty_UnitIdArray = props.data.QtyDescrptr_Qty_UnitIdArray ;
      let qtyDescrptrArray = result.QtyDescrptr_Qty_UnitIdArray;
      if(qtyDescrptrArray[0].Qty != 0 && qtyDescrptrArray[1].Qty == 0){
      result.qtyUnitArrayString = `${qtyDescrptrArray[0].Qty}${qtyDescrptrArray[0].Unit}`
      } else if(qtyDescrptrArray[0].Qty == 0 && qtyDescrptrArray[1].Qty != 0){
        result.qtyUnitArrayString = `${qtyDescrptrArray[1].Qty}${qtyDescrptrArray[1].Unit}`
      } else {
        result.qtyUnitArrayString = `${qtyDescrptrArray[0].Qty}${qtyDescrptrArray[0].Unit} ${qtyDescrptrArray[1].Qty}${qtyDescrptrArray[1].Unit}`;
      }
      result.qtyUnitArrayStringClone = result.qtyUnitArrayString
    } else if (
        props.data &&
        props.data.QtyDescrptr_Qty_UnitIdArray &&
        props.data.QtyDescrptr_Qty_UnitIdArray[0] &&
        props.data.QtyDescrptr_Qty_UnitIdArray[0].QtyDescrptr === "MinutesQty"
      ) {
        result.QtyDescrptr_Qty_UnitIdArray = props.data.QtyDescrptr_Qty_UnitIdArray;
        const qtyDescrptrArray = result.QtyDescrptr_Qty_UnitIdArray;

        const totalMinutes = Number(qtyDescrptrArray?.[0]?.Qty || 0);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        if (hours > 0 && minutes > 0) {
          result.qtyUnitArrayString = `${hours}hr${minutes}min`;
        } else if (hours > 0) {
          result.qtyUnitArrayString = `${hours}hr`;
        } else {
          result.qtyUnitArrayString = `${minutes}min`; // includes 0min
        }
        result.qtyUnitArrayStringClone = result.qtyUnitArrayString

      }
    
    else if (result.QtyDescrptr_Qty_UnitIdArray) {
      const qtyData = parseSqlArray(result.QtyDescrptr_Qty_UnitIdArray);
      result.QtyDescrptr_Qty_UnitIdArray = qtyData;
      result.qtyUnitArrayString = setQtyUnitArrayString(qtyData);
      result.qtyUnitArrayStringClone = setQtyUnitArrayString(props.selectedItem.QtyDescrptr_Qty_UnitIdArray)
    }

    if (result.DayofWeekFreqcy) {
      result.DayofWeekFreqcy = result.DayofWeekFreqcy.split(', ');
      result.DayOfWeekFreqcy = result.DayofWeekFreqcy
    }
  
    const today = new Date(window.clientDate);
    today.setHours(0, 0, 0, 0);
    const occurrenceDate = new Date(selectedItem.RcmndtnOccurncDate);
    occurrenceDate.setHours(0, 0, 0, 0);
    
    if (occurrenceDate < today) {
      setRecommendationInPast(true)
    }else {
      setRecommendationInPast(false)
    }
  

    return result;
  };

  const formatDateString = (dateString) => {  
          const [yearS, monthS, dayS] = dateString.split("-");
          const dateFormatted = `${monthS}/${dayS}/${yearS}`;
          return dateFormatted
  }

  const getDetails = () => {
    const { clientId } = window;
    RecommendationAccess.getRecommendationDetails(clientId, selectedItem.RcmndtnOccurncId)
      .then((response) => {
        if (response && response.data) {
          const result = getData(response.data[0]);
          const days = result.DayofWeekFreqcy[0].split(",");
          const days2 = result.DayofWeekFreqcy[0].split(",");

          const formatted = [days.join(", ")];
          result.DayofWeekFreqcy1 = formatted;
          result.DayofWeekFreqcyArr = days2;
          result.StartDateFormatted = formatDateString(result.StartDate);
          result.EndDateFormatted = formatDateString(result.EndDate);

          setRecommendationDetails(result);
          
          setTimeout(() => {
            setSkeleton(true);
          }, 500);
        }
      });
  };

  useEffect(() => {
    if(windowWidth > 750){
   if(dataIndex <= 4){
            setSize({left: '100%', right: 'unset'})
          } else {
            setSize({left: 'unset', right: '100%'})

          }
    } else {
   if(dataIndex <= 3){
            setSize({left: '100%', right: 'unset'})
          } else {
            setSize({left: 'unset', right: '100%'})

          }
    }

    
    getDetails();
  }, []);

    const [sizes, setSize] = useState({
      left: 0, right: 0
    });

  return (
    <>
      {!skeleton
        && <RcmndtnDetailsSkeleton dataIndex={dataIndex} windowWidth={windowWidth} sizes={sizes} />
        }

      {recommendationDetails
         && (
         <div className="selected-recommendation" style={{ left: sizes.left, right: sizes.right }}>
           <div className="card_content" style={windowWidth <= 878 ? { marginLeft: '4px' } : {}}>
             <div className={`mb-8 ${Body2500C}`}>{selectedItem.PrcsParmtrValueOne}</div>

             <div className="mb-8">
               {/* <label className={`${Body3400C}`}>Series</label> */}
               <div className={`${Body4400N}`}>{recommendationDetails.qtyUnitArrayStringClone}</div>
               {recommendationDetails.DayofWeekFreqcyArr
                        && (
                        <div className={`${Body4400U}`}>
                          {recommendationDetails.DayofWeekFreqcyArr.length === 7 ? 'DAILY' : (
                            <>
                              Occurs every
                              <span style={{ display: 'block'}}> {recommendationDetails.DayofWeekFreqcy1.map((day, index) => (
                                <span>{index !== recommendationDetails.DayofWeekFreqcy1.length - 1 ? `${day}, ` : day}</span>
                              ))
                            }
                              </span>
                            </>
                          )}
                        </div>
                        )
                    }
               <div className={`${Body4400N}`}>
                 {recommendationDetails.StartDateFormatted === recommendationDetails.EndDateFormatted ? recommendationDetails.StartDateFormatted : `${recommendationDetails.StartDateFormatted} - ${recommendationDetails.EndDateFormatted}`}
               </div>
               <div className={`${Body4300N}`}>Set by
                <span> </span>
                 <span
                   onClick={() => openUserProfile(recommendationDetails.ProviderId)}
                   className={classNameTriskeleParser(recommendationDetails.VisualNameOne, recommendationDetails.VisualTypeOne, 'Text')}
                   aria-hidden>
                   {recommendationDetails.ProviderName}
                 </span>
               </div>
             </div>

             {recommendationDetails.ChangedOccurncArray && recommendationDetails.ChangedOccurncArray.length > 0
                && (
                <div className="mb-8">
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<Icon classNames={`iconUpDown-rotation small_size ${MONTH_SELECTOR_ICON}`} />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                        >
                      <div className={`${HEADING_TEXT_2}`}>Changed Occurrence(s) within Series.</div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <table className="recommendation-details-table">
                        <tr>
                          <th className={CAPTION_TEXT_2}>Date</th>
                          <th className={CAPTION_TEXT_2}>Changed To</th>
                          <th className={CAPTION_TEXT_2}>By</th>
                        </tr>
                        {recommendationDetails.ChangedOccurncArray.map(changedOccurence => (
                          <tr>
                            <td className={CAPTION_TEXT_1}>{changedOccurence.Date}</td>
                            <td className={CAPTION_TEXT_1}>{changedOccurence.Change}</td>
                            <td className={CAPTION_TEXT_1}>{changedOccurence.By}</td>
                          </tr>
                        ))}
                      </table>
                    </AccordionDetails>
                  </Accordion>
                </div>
                )
                }

           </div>
           {!isRecommendationInPast &&
              <div style={{ display: 'flex', columnGap: '10px' }}>
              <Button variant="outlined" className="outlined-rec-btn" color="primary" onClick={() => setAction('Edit')}>Edit</Button>
              <Button variant="outlined" className="outlined-rec-btn" color="primary" onClick={() => setAction('Delete')}>Remove</Button>
            </div>
           }
          
           {action && action === 'Edit' && (
           <div className="selected-recommendation-actions left">
             <Button variant="text" onClick={() => openEditOccurenceDialog(recommendationDetails)}>Edit Occurence</Button>
             <Button variant="text" onClick={() => openEditSeriesDialog(recommendationDetails)}>Edit Series</Button>
           </div>
           )}
           {action && action === 'Delete' && (
           <div className="selected-recommendation-actions right">
             <Button variant="text" onClick={() => deleteOccurence(data.RcmndtnOccurncId)}>Remove Occurence</Button>
             <Button variant="text" onClick={() => deleteSeries(recommendationDetails.RcmndtnSeriesId)}>Remove Series</Button>
           </div>
           )}

         </div>
         )
        }
    </>
  );
};

export default RecommendationDetails;
